// extracted by mini-css-extract-plugin
module.exports = {"Banner":"banner_Banner__B1hyl","BannerImage":"banner_BannerImage__ubZ8E"};